import * as THREE from 'three';
import { Interactable } from './Interactable';
import { eventBus } from '../events/EventBus';

// ============================================
// InteractionSystem - Sistema de interacción
// ============================================

const INTERACTION_DISTANCE = 2.5;

export class InteractionSystem {
  private camera: THREE.PerspectiveCamera | null = null;
  private interactables: Map<string, Interactable> = new Map();
  private currentTarget: Interactable | null = null;

  init(camera: THREE.PerspectiveCamera, _scene: THREE.Scene): void {
    this.camera = camera;
    console.log('[InteractionSystem] Inicializado');
  }

  register(options: import('./Interactable').InteractableOptions): void {
    const interactable = new Interactable(options);
    this.interactables.set(options.id, interactable);
  }

  unregister(id: string): void {
    this.interactables.delete(id);
  }

  update(): void {
    if (!this.camera) return;

    const playerPosition = this.camera.position;
    let closest: Interactable | null = null;
    let closestDistance = INTERACTION_DISTANCE;

    // Buscar el interactable más cercano
    for (const interactable of this.interactables.values()) {
      if (!interactable.canInteract()) continue;

      const distance = interactable.getDistanceTo(playerPosition);
      if (distance < closestDistance) {
        closest = interactable;
        closestDistance = distance;
      }
    }

    // Actualizar objetivo actual
    if (closest !== this.currentTarget) {
      if (this.currentTarget) {
        this.currentTarget.unhover();
      }

      this.currentTarget = closest;

      if (this.currentTarget) {
        this.currentTarget.hover();
        eventBus.emit('interaction:available', {
          id: this.currentTarget.id,
          label: this.currentTarget.label,
        });
      } else {
        eventBus.emit('interaction:unavailable', undefined);
      }
    }
  }

  interact(): void {
    if (this.currentTarget && this.currentTarget.canInteract()) {
      this.currentTarget.interact();
      eventBus.emit('interaction:triggered', this.currentTarget.id);
    }
  }

  getCurrentTarget(): Interactable | null {
    return this.currentTarget;
  }

  getInteractables(): Interactable[] {
    return Array.from(this.interactables.values());
  }

  clear(): void {
    this.interactables.clear();
    this.currentTarget = null;
  }
}
